import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { IoBagCheck, IoCloseCircle, IoAddCircle } from "react-icons/io5";
import "./component.css";

const RencanaTanamMasuk = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);

  const fetchRencanaTanam = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    setMsg("");

    try {
      console.log("Fetching data from API...");

      const response = await axios.get(
        "https://c-greenproject.org:8000/petanis",
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );

      let formattedData = [];

      if (response.data && Array.isArray(response.data.data)) {
        formattedData = response.data.data.flatMap((item) =>
          Array.isArray(item.rencanaTanamInfo) ? item.rencanaTanamInfo : []
        );
      }

      console.log("Formatted Data:", formattedData);

      if (formattedData.length === 0) {
        console.warn("No valid data found in API response.");
      }

      setProducts(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setMsg(
        error.response?.data?.msg || "Gagal mengambil data. Coba lagi nanti."
      );
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (idtanam, statusRencanaTanam) => {
    const token = localStorage.getItem("token");
    setLoading(true);

    try {
      await axios.patch(
        `https://c-greenproject.org:8000/rencanatanam/${idtanam}`,
        { statusRencanaTanam },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );
      fetchRencanaTanam();
    } catch (error) {
      setMsg(
        error.response?.data?.msg || "Gagal memperbarui data. Coba lagi nanti."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRencanaTanam();
  }, []);

  return (
    <div>
      <h2 className="title">
        <strong>Rencana Tanam Masuk</strong>
      </h2>

      {user.role === "petani" && (
        <button
          className="btn btn-primary my-3"
          onClick={() => navigate("/rencanatanam/add")}
        >
          <IoAddCircle /> Tambah Rencana Tanam
        </button>
      )}
      {loading && <p className="notification is-info">Loading...</p>}

      {msg && <p className="notification is-danger">{msg}</p>}

     
      {console.log("Current Products State:", products)}
      <div className="detail-table-container">
        <table className="table is-striped is-fullwidth detail-table">
          <thead>
            <tr className="text-center">
              <th>No</th>
              <th>ID Tanam</th>
              <th>Status</th>
              <th>Varietas Singkong</th>
              <th>Estimasi Produksi (kg)</th>
              <th>Tanggal Rencana Tanam</th>
              <th>Tanggal Rencana Panen</th>
              {user?.role === "perusahaan" && <th>Actions</th>}
            </tr>
          </thead>
          <tbody className="text-center">
            {products.length > 0 ? (
              products.map((product, index) => (
                <React.Fragment key={product.idtanam || index}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{product.idtanam || "N/A"}</td>
                    <td>{product.statusRencanaTanam || "N/A"}</td>
                    <td>{product.varietassingkong || "N/A"}</td>
                    <td>{product.estimasiproduksi || "N/A"}</td>
                    <td>{product.tanggalRencanaTanam || "N/A"}</td>
                    <td>{product.tanggalRencanaPanen || "N/A"}</td>

                    {user?.role === "perusahaan" && (
                      <td>
                        <button
                          className="btn btn-success mt-2 button-tabel"
                          onClick={() =>
                            updateStatus(
                              product.idtanam,
                              "Rencana Tanam Disetujui"
                            )
                          }
                        >
                          <IoBagCheck /> Setujui
                        </button>
                        <button
                          className="btn btn-danger mt-2 button-tabel"
                          onClick={() =>
                            updateStatus(
                              product.idtanam,
                              "Rencana Tanam Ditolak"
                            )
                          }
                        >
                          <IoCloseCircle /> Tolak
                        </button>
                      </td>
                    )}
                  </tr>
                </React.Fragment>
              ))
            ) : !loading ? (
              <tr>
                <td colSpan="8" className="text-center">
                  Tidak ada data tersedia.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>

      {msg && <p className="notification is-danger">{msg}</p>}
      {loading && <p className="notification is-info">Loading...</p>}
    </div>
  );
};

export default RencanaTanamMasuk;
